import React, { useContext, useState } from "react";
import { FormControl, IconButton } from "@mui/material";
import NoTicketDetail from "../../../FlightPackage/NoTicketDetail";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/AddCircleOutline";
import { TicketLineItemExtended } from "../../../Utils/TypeExtensions";
import { LANDING_LINE_ITEM_TYPES } from "../../../sharedCode/metadata";
import DetailPage from "../../../Components/navigation/detailPage";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import { GlobalContext } from "../../../Utils/Contexts";
import LandingRow from "../../../Components/ticket/landingRow";
import { TicketLineItem } from "../../../sharedCode/avroGraphql";
import DeleteConfirmationDialog from "../../../Components/DeleteConfirmationDialog";
import { isLandingLineItem } from "../../../Components/validation/newHelpers";
import { addLineItem, saveTicketChanges } from "../../../Utils/TicketDatabase";

// TODO why did I have to create fuel and charges details but here there's no issue?
interface State {
    ShowDeleteConfirmation: boolean;
    IdToDelete: number;
}

export function TicketLandings(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);

    const [localState, setLocalState] = useState<State>({
        ShowDeleteConfirmation: false,
        IdToDelete: 0,
    });

    if (!props.ticket) return <NoTicketDetail />;

    const listItems = (props.ticket.LineItems?.filter((r) => isLandingLineItem(r)) ?? []).map((lineItem) => (
        <LandingRow
            key={`row${lineItem?.id}-${props.ticket.LineItems?.length}`}
            lineItem={lineItem as TicketLineItem}
            handleDelete={handleDelete}
            mergeRowChanges={mergeRowChanges}
            {...props}
        />
    ));

    return (
        <DetailPage>
            <FormControl fullWidth>
                {localState.ShowDeleteConfirmation && <DeleteConfirmationDialog entityName={"LANDING"} onClose={handleDeleteCanceled} onConfirm={handleDeleteConfirmed} />}
                {listItems}
                <Typography>
                    <IconButton disabled={props.isReadOnly} size="large" color="inherit" sx={{ ml: 2, mr: 2, alignItems: "left" }} onClick={handleAdd}>
                        <AddIcon />
                    </IconButton>
                </Typography>
            </FormControl>
        </DetailPage>
    );

    function handleAdd(): void {
        const id = props.ticket.nextLocalId;
        const newLineItem = {
            id,
            comments: "",
            ticket_id: props.ticket.id,
            line_item_type_id: LANDING_LINE_ITEM_TYPES[0],
        } as TicketLineItemExtended;

        addLineItem(props.ticket.id, newLineItem).catch(() => props.showForceReloadDialogue());
    }

    function handleDelete(lineItemToDelete: TicketLineItem): void {
        setLocalState((prev) => {
            return { ...prev, ShowDeleteConfirmation: true, IdToDelete: lineItemToDelete.id };
        });
    }

    function handleDeleteCanceled(): void {
        setLocalState((prev) => {
            return { ...prev, ShowDeleteConfirmation: false, IdToDelete: 0 };
        });
    }

    function handleDeleteConfirmed(): void {
        if (!props.ticket.LineItems) return;
        const lineItemToDelete = props.ticket.LineItems.find((p) => p?.id === localState.IdToDelete);
        if (lineItemToDelete) {
            const indexToDelete = props.ticket.LineItems.indexOf(lineItemToDelete);
            if (indexToDelete > -1) {
                const newList = [...props.ticket.LineItems.slice(0, indexToDelete), ...props.ticket.LineItems.slice(indexToDelete + 1)];
                saveTicketChanges(props.ticket.id, { LineItems: newList }).catch(() => props.showForceReloadDialogue());
            }
        }
    }

    function mergeRowChanges(locationId: number, changes: Record<string, unknown>) {
        const lineItems = props.ticket?.LineItems?.map((lineItem) => {
            if (lineItem?.id === locationId) {
                return { ...lineItem, ...changes } as TicketLineItemExtended;
            } else {
                return lineItem;
            }
        });

        saveTicketChanges(props.ticket.id, { LineItems: lineItems }).catch(() => props.showForceReloadDialogue());
    }
}
